module.exports = __webpack_public_path__ + "08a59ba4e48f37542e8d3e438aa2fcc9.svg";